import { render } from "./comentarioCreate.vue?vue&type=template&id=4a8d6444"
import script from "./comentarioCreate.vue?vue&type=script&lang=js"
export * from "./comentarioCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__